import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './positive.module.scss';

const METADATA = Metadata.define({
  description: 'Primary positive badge indicator.',
  name: 'Positive Primary Badge',
});

export default class SpdsIndicatorBadgePositivePrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  variantClass = 'spds-indicator-badge-positive';
  variantStyles = styles;
}

export const BADGE_POSITIVE_PRIMARY_METADATA = SpdsIndicatorBadgePositivePrimary.metadata;
